import * as React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/excite';
import { ResetButton } from 'webapp/components/button/button';

type PropType = {
  bullets: string[];
  scrollToSpecifications: () => void;
};

export const BulletList = (props: PropType) => {
  return props.bullets && props.bullets.length > 0 ? (
    <Container>
      <HeaderRow>
        <Header>{translate(t => t.productPage.bulletListHeader)}</Header>
        <ShowMoreButton onClick={props.scrollToSpecifications}>
          {translate(t => t.productPage.bulletListShowMore)}
        </ShowMoreButton>
      </HeaderRow>
      <List>
        {props.bullets.map((item, i) => (
          <ListItem key={i}>{item}</ListItem>
        ))}
      </List>
    </Container>
  ) : null;
};

const Container = styled.div({
  marginBottom: t => t.sharedSpacing.xl,
});

const HeaderRow = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: t => t.sharedSpacing.m,
});

const Header = styled.h3({
  fontSize: t => t.sharedFontSize.l,
  fontWeight: 450,
  marginBottom: 0,
});

const ShowMoreButton = styled(ResetButton, {
  fontSize: t => t.sharedFontSize.xs,
  textDecoration: 'underline',
});

const List = styled.ul({
  marginBottom: 0,
});

const ListItem = styled.li({
  fontSize: t => t.sharedFontSize.xs,
  fontWeight: 400,
  marginBottom: 6,
  ':last-child': {
    marginBottom: 0,
  },
});
